import { Field, useField } from 'formik';
import React, { FC } from 'react';

// Components
import FormikError from '../FormikError';

// Styles
import { FormikTextAreaProps } from '../../../models/Formik';

const FormikTextArea: FC<FormikTextAreaProps> = ({
  name,
  label,
  subLabel,
  rows,
  ...rest
}) => {
  const [, meta] = useField(name);
  return (
    <div className="aea-form-textarea">
      <label className="aea-form-textarea__label" htmlFor={name}>
        {label}
      </label>
      {subLabel && (
        <label className="aea-form-textarea__sublabel">{subLabel}</label>
      )}
      <Field as="textarea" id={name} name={name} rows={rows} {...rest} />
      {meta.touched && meta.error && <FormikError name={name} />}
    </div>
  );
};

export default FormikTextArea;
